module.exports = __webpack_public_path__ + "img/ai-input-library.069f2393.svg";